import TockReservationsNotice, { ComponentUnderTest } from './TockReservationsNotice';

export { ComponentUnderTest };
export default TockReservationsNotice;
